import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Colors } from '../../theme';

export const BackButton = styled(Button)(() => ({
  alignSelf: 'flex-start',
  marginLeft: -8,
  marginBottom: -8,
  padding: '4px 8px',
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.9rem',
  fontWeight: 600,
  textTransform: 'none',
  '@media (hover: hover)': {
    '&:hover': {
      color: Colors.WHITE,
      background: Colors.INPUT_ON_DARK,
    },
  },
}));

export const Heading = styled('header')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  textAlign: 'center',
}));

export const Title = styled(Typography)(() => ({
  color: Colors.WHITE,
  fontSize: '1.6rem',
  fontWeight: 700,
  lineHeight: 1.2,
}));

export const SubTitle = styled(Typography)(() => ({
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.95rem',
  lineHeight: 1.5,
}));

export const Destination = styled('strong')(() => ({
  color: Colors.WHITE,
  fontWeight: 700,
  whiteSpace: 'nowrap',
}));

export const CodeArea = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  // Reserva el espacio del mensaje para que nada salte al aparecer.
  minHeight: 88,
}));

export const StatusText = styled(Typography)(() => ({
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.9rem',
  textAlign: 'center',
}));

export const ErrorText = styled(Typography)(() => ({
  color: Colors.ERROR_TEXT_LIGHT,
  fontSize: '0.9rem',
  textAlign: 'center',
}));

export const ResendRow = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  minHeight: 40,
  alignItems: 'center',
}));

export const ResendHint = styled(Typography)(() => ({
  color: Colors.TEXT_ON_DARK_SUBTLE,
  fontSize: '0.9rem',
  textAlign: 'center',
  fontVariantNumeric: 'tabular-nums',
  '& strong': {
    color: Colors.TEXT_ON_DARK_MUTED,
  },
}));

export const ResendButton = styled(Button)(() => ({
  color: Colors.GREEN_BACKGROUND,
  fontSize: '0.95rem',
  fontWeight: 700,
  textTransform: 'none',
  borderRadius: 10,
  '@media (hover: hover)': {
    '&:hover': {
      background: Colors.INPUT_ON_DARK,
    },
  },
}));
